import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import { db } from '../../services/firebase_services';
import { CommunityModel } from '../../models/CommunityModel';
import { primaryColor, shadow } from '../../assets/styles/styles';
import { BorderBottom } from '@mui/icons-material';
import { TypographyNestedContext } from '@mui/joy/Typography/Typography';
import { getMobileOperatingSystem } from '../../services/general_services';
import { getCurrentDateTime } from '../../services/home_services';

export function ViewCommunity() {
  const { id } = useParams();

  const [community, setCommunity] = useState<undefined | CommunityModel>(
    undefined
  );
  const [members, setMembers] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showFullDesc, setShowFullDesc] = useState(false);
  const [shouldShowToggle, setShouldShowToggle] = useState(false);
  const descRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (descRef.current && community) {
      console.log(descRef.current.scrollHeight > 20);
      setShouldShowToggle(descRef.current.scrollHeight > 20); // 2 lines ~30px
    }
  }, [descRef.current]);

  // useEffect(() => {
  //   setTimeout(() => {}, 500);
  //   setShouldShowToggle(descRef.current.scrollHeight > 20); // 2 lines ~30px
  // }, [community]);

  async function getCommunity() {
    try {
      setLoading(true);
      let comm = (
        await db.ref('/new_data/community_data/communities/' + id).once('value')
      ).val();

      console.log(comm);
      if (comm !== null) {
        setCommunity(comm);
        setShouldShowToggle(comm.desc && comm.desc.length > 100);
        let comms = await db
          .ref('/new_data/community_data/community_users/' + comm.communityId)
          .orderByChild('active')
          .equalTo(true)
          .once('value');

        setMembers(comms.numChildren());
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }
  useEffect(() => {
    if (id) {
      getCommunity();
    }
  }, [id]);
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const appTrigger = params.get('appTrigger');
  const link = params.get('link');

  const deepLink = 'routebuddies://';

  useEffect(() => {
    let fallbackTimeout: any;

    const redirectToDeepLink = () => {
      let location = deepLink;

      if (id && link) {
        location += `${link}/${id}`;
      } else if (link) {
        location += link;
      }

      console.log('Trying deep link:', location);

      // Create an iframe to attempt opening the deep link
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = location;
      document.body.appendChild(iframe);

      // Remove the iframe after attempting
      setTimeout(() => document.body.removeChild(iframe), 1000);
    };

    const redirectToFallback = () => {
      const platform = getMobileOperatingSystem();
      const fallbackLink =
        platform === 'Android'
          ? 'https://play.google.com/store/apps/details?id=com.routebuddies'
          : 'https://apps.apple.com/gb/app/routebuddies/id6443986928';

      console.log('Fallback?');
      window.location.href = fallbackLink;
    };

    const tryRedirect = () => {
      try {
        redirectToDeepLink();

        fallbackTimeout = setTimeout(() => {
          redirectToFallback();
        }, 200); // Adjust timeout as needed
      } catch (err) {
        console.log(err);
      }
    };

    const handleBlur = () => {
      // If the window loses focus before the timeout fires, clear the timeout
      clearTimeout(fallbackTimeout);
    };

    if (appTrigger) {
      tryRedirect();

      window.addEventListener('blur', handleBlur);

      // Cleanup function to remove the event listener
      return () => {
        window.removeEventListener('blur', handleBlur);
      };
    }
  }, [appTrigger]);
  return (
    <Grid
      container
      justifyContent={'center'}
      alignContent={loading ? 'center' : 'flex-start'}
      style={{
        backgroundColor: 'white',
        paddingBottom: 20,
      }}
    >
      {loading ? (
        <Grid
          container
          sx={{ height: '100vh' }}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <CircularProgress />
        </Grid>
      ) : !community ? (
        <Grid
          container
          item
          xs={12}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'100vh'}
        >
          <Grid
            item
            container
            xs={12}
            sm={6}
            justifyContent={'center'}
            alignItems={'center'}
            flexDirection={'column'}
            rowSpacing={2}
          >
            <Grid item>
              <img src={'/static/searching.png'} width={400} />
            </Grid>
            <Grid item>
              <Typography variant={'h4'}>Private Community</Typography>
            </Grid>
            <Grid item>
              <Typography variant={'body1'}>
                View this community in-app to join / request to join.
              </Typography>
            </Grid>
            <></>
            <Grid item>
              <Button
                variant={'contained'}
                onClick={() => {
                  window.location.href = '/';
                }}
              >
                Take me home!
              </Button>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid
          item
          xs={12}
          sm={10}
          md={8}
          lg={6}
          style={{
            borderRadius: 10,
            marginTop: '15px',
            flex: 1,
            height: '100vh',
            backgroundColor: '#fff',
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              borderRadius: 10,
              overflow: 'hidden',
            }}
          >
            <Grid
              item
              container
              xs={12}
              justifyContent={'center'}
              alignItems={'center'}
              style={{ marginTop: '15px' }}
            >
              <Grid container alignItems={'center'} flexDirection={'column'}>
                <img
                  src={'/static/red_logo_thick.png'}
                  style={{ width: 100, maxWidth: 100, marginBottom: 5 }}
                />
                <Typography
                  variant="h6"
                  fontWeight={'700'}
                  style={{ color: primaryColor }}
                >
                  RouteBuddies
                </Typography>
              </Grid>

              <Grid
                container
                item
                justifyContent={'center'}
                flexDirection={'row'}
                spacing={5}
                paddingTop={5}
              >
                <Grid
                  item
                  container
                  justifyContent={'center'}
                  sx={{
                    display: {
                      xs: 'flex',
                      md: 'none',
                    },
                  }}
                >
                  <div
                    style={{
                      position: 'relative',
                      width: '100%',
                      maxWidth: '80%',
                      marginTop: -40,
                    }}
                  >
                    <div
                      style={{
                        width: '100%',
                        paddingTop: '140%', // 2:3 aspect ratio
                        backgroundImage: `url('/static/comm_app.png')`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: 8,
                        position: 'relative',
                      }}
                    />

                    {/* Community image (absolute overlay) */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '33.2%',
                        left: '16.7%',
                        width: '16.8%',
                        aspectRatio: '1',
                        borderRadius: 1,
                        backgroundImage: `url(${community?.imageUrl})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                      }}
                    />

                    {/* Text overlay (absolute overlay) */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '34%',
                        left: '37%',
                        width: '45%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: 'white',
                          fontWeight: 'bold',
                          fontSize: '0.8rem',
                          lineHeight: 1.2,
                          display: '-webkit-box',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          fontFamily: 'Urbanist',
                        }}
                      >
                        {community.name}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: 'white',
                          fontSize: '0.4rem',
                          maxHeight: 15,
                          lineHeight: 1.1,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          marginTop: 0.3,
                        }}
                      >
                        {community.desc}
                      </Typography>
                    </Box>
                  </div>
                </Grid>
                <Grid
                  item
                  container
                  justifyContent={'center'}
                  sx={{
                    display: {
                      xs: 'none',
                      md: 'flex',
                    },
                  }}
                >
                  <div
                    style={{
                      position: 'relative',
                      width: '100%',
                      maxWidth: '50%',
                      marginTop: -40,
                    }}
                  >
                    <div
                      style={{
                        width: '100%',
                        paddingTop: '140%', // 2:3 aspect ratio
                        backgroundImage: `url('/static/comm_app.png')`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: 8,
                        position: 'relative',
                      }}
                    />

                    {/* Community image (absolute overlay) */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '33.2%',
                        left: '16.7%',
                        width: '16.8%',
                        aspectRatio: '1',
                        borderRadius: 1,
                        backgroundImage: `url(${community?.imageUrl})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                      }}
                    />

                    {/* Text overlay (absolute overlay) */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '34%',
                        left: '37%',
                        width: '45%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: 'white',
                          fontWeight: 'bold',
                          fontSize: '0.8rem',
                          lineHeight: 1.2,
                          display: '-webkit-box',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          fontFamily: 'Urbanist',
                        }}
                      >
                        {community.name}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: 'white',
                          fontSize: '0.4rem',
                          maxHeight: 15,
                          lineHeight: 1.1,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          marginTop: 0.3,
                        }}
                      >
                        {community.desc}
                      </Typography>
                    </Box>
                  </div>
                </Grid>
                <Grid item container justifyContent={'center'}>
                  <Grid item xs={10}>
                    <Typography variant="body1" textAlign={'center'}>
                      See what {community.name} are up to in the RouteBuddies
                      app.
                    </Typography>
                  </Grid>
                </Grid>

                <Grid item>
                  <Button
                    onClick={() => {
                      window.location.href =
                        'https://routebuddies.com/communities/' +
                        community.communityId +
                        '?appTrigger=true';
                    }}
                    variant="contained"
                    style={{
                      padding: 15,
                      borderRadius: 40,
                      width: 250,
                    }}
                  >
                    <Typography fontWeight={'bold'}>View in App</Typography>
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
